import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMAssetsInventorySearch, ISCMAssetsInventoryDetail, ISCMAssetsInventoryStatistics, ISCMAssetsInventoryInsert, ISCMAssetsInventoryUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./assetsInventoryTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class AssetsInventoryService {
    async page(searchVo: ISCMAssetsInventorySearch) {
        const apiUrl = "/assets/stocktaking/page";
        return await httpRequest.post<IPage<ISCMAssetsInventoryDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMAssetsInventorySearch) {
        const apiUrl = "/assets/stocktaking/total";
        return await httpRequest.post<ISCMAssetsInventoryStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/stocktaking/findById/${id}`
        return await httpRequest.get<ISCMAssetsInventoryDetail>(apiUrl)
    }
    async insert(insertVo: ISCMAssetsInventoryInsert) {
        const apiUrl = '/assets/stocktaking/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMAssetsInventoryInsert) {
        const apiUrl = '/assets/stocktaking/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async export(searchVo: ISCMAssetsInventorySearch) {
        const apiUrl = "/assets/stocktaking/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    //盘点完成
    async complete(params: object) {
        const apiUrl = "/assets/stocktaking/complete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //盘点审核
    async finalAudit(params: object) {
        const apiUrl = "/assets/stocktaking/finalAudit";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    // async print(id: string) {
    //     const apiUrl = `/sms/transfer/to/print/${id}`;
    //     return await httpRequest.get<boolean>(apiUrl);
    // }

    //资产明细查询接口
    async assetsListDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/assets/assets/detailsPage";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/assets/stocktaking/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
}

export const assetsInventoryService = new AssetsInventoryService();